import React from 'react';
import styled from 'styled-components';
import {
  cssColorValue,
  desktopFinale,
  desktopMesto,
  screenMdMin,
} from '@spotify-internal/encore-web-v6';

const copyrightYear = new Date().getFullYear();

const CopyrightWrapper = styled.div`
  color: ${cssColorValue('textSubdued')};
  ${() => desktopFinale}
  @media (min-width: ${screenMdMin}) {
    ${() => desktopMesto}
  }
`;

export const Copyright = () => (
  <CopyrightWrapper>&#169; {copyrightYear} Spotify AB</CopyrightWrapper>
);
